import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { toRoman } from 'helpers'
import { connect } from 'react-redux'

import {
    AUCTION_BET_APPLIED,
    AUCTION_START_FROM,
    OTHER_REWARD_SELECTED,
    PFP_NAME,
    REWARD_RECEIVED,
    TANK_IS_IN_HANGAR,
} from '../../translations'

import { Bons, sendClickSoundCommand, sendHoverSoundCommand } from 'react-wot-bootstrap'
import { isCnRealm } from 'containers/WGCWXShop/helpers'

import { CARD_STATUS_TYPES } from './constants'

import {
    BalancePropTypes,
    RewardsMetaPropTypes,
    RewardPropTypes,
} from 'containers/WGCWXShop/propTypes'

import VehicleAddToComparison from 'components/VehicleAddToComparison/VehicleAddToComparison'
import VehicleType from 'components/VehicleType/VehicleType'
import FamePoints from 'components/FamePoints/FamePoints'

import styles from './WGCWXRewardsTankCard.scss'

export class WGCWXRewardsTankCard extends React.Component {
    static propTypes = {
        tank: RewardPropTypes,
        tanks: PropTypes.arrayOf(RewardPropTypes),
        rewardsMeta: RewardsMetaPropTypes,
        accountBalance: BalancePropTypes,
        selectReward: PropTypes.func.isRequired,
        isAddToComparisonAvailable: PropTypes.bool.isRequired,
        realm: PropTypes.string.isRequired,
    }

    constructor(props) {
        super(props)

        this.state = {
            cardStatus: this.defineCardStatus(),
        }
    }

    handleMouseEnter = () => {
        sendHoverSoundCommand()
    }

    handleMouseDown = () => {
        sendClickSoundCommand()
    }

    handleClick = rewardId => event => {
        event.preventDefault()
        this.props.selectReward(rewardId)
    }

    renderCompareComponent = (vehicleId) => {
        if (!this.props.isAddToComparisonAvailable) return null

        return (
            <VehicleAddToComparison
                vehicleCd={vehicleId}
                mixClassName={styles.addToCompare}
            />
        )
    }

    islackOfBonds = () => {
        const { minBet, famePoints, hasAuctionTicket } = this.props.rewardsMeta
        const { price, secondPrice } = this.props.tank
        const { crystal: bonds } = this.props.accountBalance
        const isEnoughPfp = (famePoints >= price)

        if (hasAuctionTicket) {
            return isEnoughPfp ? (bonds < secondPrice) : (bonds < minBet)
        } else {
            return bonds < secondPrice
        }
    }

    defineCardStatus = () => {
        const {
            famePoints,
            currentBet,
            hasAuctionTicket,
        } = this.props.rewardsMeta
        const {
            inHangar,
            token,
            price,
        } = this.props.tank

        const isRewardingStarted = this.props.tanks.every(tank => tank.price > 0)

        const selectedTankInfo = this.props.tanks.find(tank => tank.isSelected)
        const isCurrentTankSelected = (selectedTankInfo && selectedTankInfo.token === token)

        const isEnoughPfp = (famePoints >= price)

        switch (true) {
        case inHangar && !isCurrentTankSelected:
            return CARD_STATUS_TYPES.TANK_IN_HANGAR

        case isCurrentTankSelected && !currentBet:
            return CARD_STATUS_TYPES.REWARD_RECEIVED

        case selectedTankInfo && !isCurrentTankSelected:
            return CARD_STATUS_TYPES.OTHER_REWARD_SELECTED

        case !isRewardingStarted:
            return CARD_STATUS_TYPES.REWARDING_NOT_STARTED

        case (!selectedTankInfo && isEnoughPfp) || (!hasAuctionTicket && !currentBet):
            return CARD_STATUS_TYPES.REWARDING_STARTED

        case !isEnoughPfp && !currentBet:
            return CARD_STATUS_TYPES.AUCTION_AVAILABLE

        default:
            return CARD_STATUS_TYPES.AUCTION_BET_APPLIED
        }
    }

    renderTankStatus = () => {
        const { cardStatus } = this.state
        const { currentBet, minBet } = this.props.rewardsMeta
        const { price, secondPrice } = this.props.tank
        const { isWGMoneyAvailable } = this.props.accountBalance

        let lackOfBonds = false

        if (isWGMoneyAvailable) {
            lackOfBonds = this.islackOfBonds()
        }

        const okIconClassNames = classNames(styles.statusIcon, styles.statusIcon__ok)
        const hangarIconClassNames = classNames(styles.statusIcon, styles.statusIcon__inHangar)
        const lockedIconClassNames = classNames(styles.statusIcon, styles.statusIcon__locked)
        const bondsClassNames = classNames(styles.bonds, {
            [styles.bonds__notEnough]: lackOfBonds,
        })

        switch (cardStatus) {
        case CARD_STATUS_TYPES.TANK_IN_HANGAR:
            return (
                <div className={styles.status}>
                    <span className={hangarIconClassNames}/>
                    {TANK_IS_IN_HANGAR}
                </div>
            )

        case CARD_STATUS_TYPES.REWARD_RECEIVED:
            return (
                <div className={styles.status}>
                    <span className={okIconClassNames}/>
                    {REWARD_RECEIVED}
                </div>
            )

        case CARD_STATUS_TYPES.OTHER_REWARD_SELECTED:
            return (
                <div className={styles.status}>
                    <span className={lockedIconClassNames}/>
                    {OTHER_REWARD_SELECTED}
                </div>
            )

        case CARD_STATUS_TYPES.REWARDING_NOT_STARTED:
            return (
                <div className={styles.status}>
                    <Bons
                        size="large"
                        iconPosition="after"
                        value={secondPrice}
                        mixClassName={styles.bonds}
                    />
                    <span className={styles.plus} />
                    {PFP_NAME}
                </div>
            )

        case CARD_STATUS_TYPES.REWARDING_STARTED:
            return (
                <div className={styles.status}>
                    <Bons
                        size="large"
                        iconPosition="after"
                        value={secondPrice}
                        mixClassName={bondsClassNames}
                    />
                    <span className={styles.plus} />
                    <FamePoints
                        value={price}
                        size="medium"
                    />
                </div>
            )

        case CARD_STATUS_TYPES.AUCTION_AVAILABLE:
            return (
                <div className={styles.status}>
                    {AUCTION_START_FROM}
                    <Bons
                        size="large"
                        iconPosition="after"
                        value={minBet}
                        mixClassName={classNames(bondsClassNames, styles.bonds__afterText)}
                    />
                </div>
            )
        case CARD_STATUS_TYPES.AUCTION_BET_APPLIED:
            return (
                <div className={styles.status}>
                    <span className={okIconClassNames}/>
                    {AUCTION_BET_APPLIED}
                    {
                        isWGMoneyAvailable &&
                        <Bons
                            size="large"
                            iconPosition="after"
                            value={currentBet}
                            mixClassName={classNames(styles.bonds, styles.bonds__afterText)}
                        />
                    }
                </div>
            )
        }
    }

    render() {
        const { id } = this.props.tank
        const {
            level,
            type,
            userName,
            vehicleId,
            isPremium,
        } = this.props.tank.vehicleParams

        const isSuccessCard = (
            this.state.cardStatus === CARD_STATUS_TYPES.REWARD_RECEIVED ||
            this.state.cardStatus === CARD_STATUS_TYPES.AUCTION_BET_APPLIED
        )

        const tankImageClassNames = classNames(
            styles.tank,
            styles[`tank__${vehicleId}`],
            isCnRealm(this.props.realm) && styles.isCnRealm,
        )
        const cardClassNames = classNames(styles.base, {
            [styles.base__success]: isSuccessCard,
        })

        const tankLevel = toRoman(level)

        return (
            <div
                className={cardClassNames}
                onMouseEnter={this.handleMouseEnter}
                onMouseDown={this.handleMouseDown}
                onClick={this.handleClick(id)}
                id={`reward-pack-${id}`}
            >
                {this.renderCompareComponent(vehicleId)}
                <div className={styles.holder}>
                    <span className={tankImageClassNames}/>
                    <p className={styles.info}>
                        <span className={styles.level}>{tankLevel}</span>
                        <VehicleType type={type} premium={isPremium}/>
                        <span className={styles.name}>{userName}</span>
                    </p>
                    {this.renderTankStatus()}
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        realm: state.settings.realm,
    }
}

export default connect(mapStateToProps)(WGCWXRewardsTankCard)



// WEBPACK FOOTER //
// ./containers/WGCWXShop/containers/WGCWXRewards/components/WGCWXRewardsTankCard/WGCWXRewardsTankCard.jsx